import styled from 'styled-components';
import { Page as ConstellationPage } from '@zillow/constellation';

export const Content = styled.main`
  padding: 16px;
  padding-bottom: 60px;
  max-width: 1280px;
  width: 100%;
  background-color: white;
`;

export const Page = styled(ConstellationPage)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
